module.exports = __webpack_public_path__ + "img/youtube.19934490.svg";